export const verifyApiEnv = () => {
    const {REACT_APP_API_ENV}   = process.env;
    const envOptions            = ['dev', 'dev_in', 'staging', 'prod', 'prod_sa', 'prod_sg', 'prod_eu'];
    const isApiConfigured       = envOptions.some(option => (REACT_APP_API_ENV === option));

    if (!isApiConfigured) {
        throw new Error(`Must set REACT_APP_API_ENV in .env file at app root. Options: ${envOptions.join(' | ')}`)
    }    
}